/*eslint-disable*/
import api from '../index'

class TemplateApi {

  // GET: template/:id
  static show(id) {
    return api.axios.get('/template/' + id).then(response => response.data);
  }

  // POST: template
  static create(template) {
    return api.axios.post('/template', template).then(response => response.data.homeworkTemplate);
  }

  //PUT: template/:id
  static update(id, template) {
    return api.axios.put('/template/' + id, template).then(response => response.data.homeworkTemplate);
  }


  // GET: template
  static list(params, cancelToken = null) {
    return api.axios.get('/template', {params, cancelToken}).then(response => response.data);
  }

  // DELETE: template/:id
  static delete(id) {
    return api.axios.delete('/template/' + id).then(response => response.data);
  }
}

export default TemplateApi;
